import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import pageHeader from '../../assets/images/pageHeader.a8555e51.jpg';

// Import gallery images
import baptismGroup from '../../assets/images/baptism_group.74b5a71a.jpg';
import baptismGroup2 from '../../assets/images/baptism_group_2.3761f9cd.jpg';
import choirSinging from '../../assets/images/choir_singing_red.36d7c7e6.jpg';
import churchExt from '../../assets/images/church_ext.049841a2.jpg';
import churchGroup from '../../assets/images/church_group.f1a61664.jpg';
import concert from '../../assets/images/concert.73a5d892.jpg';
import marriage from '../../assets/images/marriage.5e7e1726.jpg';

const About = () => {
  const { t } = useTranslation();

  const galleryImages = [
    { src: baptismGroup, alt: 'Baptism Group' },
    { src: baptismGroup2, alt: 'Baptism Group 2' },
    { src: choirSinging, alt: 'Choir Singing' },
    { src: churchExt, alt: 'Church Exterior' },
    { src: churchGroup, alt: 'Church Group' },
    { src: concert, alt: 'Concert' },
    { src: marriage, alt: 'Marriage Ceremony' }
  ];

  return (
    <div className="about-page">
      {/* Page Header */}
      <div
        className="page-header py-5"
        style={{
          backgroundImage: `url(${pageHeader})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <Container>
          <h1 className="text-white">{t('about_us')}</h1>
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('about_us_page.page_header.home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('about_us_page.page_header.about')}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      {/* Content Section */}
      <Container className="my-5">
        <Row>
          <Col>
            <h2>{t('about_us_page.title')}</h2>
            <p className="">{t('about_us_page.first_section')}</p>
            <p>{t('about_us_page.second_section')}</p>
            <p>{t('about_us_page.third_section')}</p>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col>
            <h3>{t('about_us_page.our_mission.title')}</h3>
            <p>{t('about_us_page.our_mission.description')}</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
